import React from 'react';
export var I18nContext = /*#__PURE__*/React.createContext({
  lang: 'zh-cn',
  langJson: {},
  t: function t(a) {
    return a;
  },
  tHTML: function tHTML(a) {
    return a;
  }
});